var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepth2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 445,
    height: 960,
    viewBox: "0 0 445 960",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4148_19449)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4148_19449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M605 318C605 943.738 426.809 1451 207 1451C-12.8094 1451 -191 943.738 -191 318C-191 -307.739 -12.8093 -815 207 -815C426.809 -815 605 -307.739 605 318ZM366 413.5C366 382.978 347.398 356.862 321.063 346.17C343.167 314.856 356.805 271.902 356.805 224.508C356.805 128.686 301.064 51.0078 232.305 51.0078C163.545 51.0078 107.805 128.686 107.805 224.508C107.805 289.018 133.07 345.304 170.562 375.201C122.173 400.373 87.9999 461.761 87.9999 533.5C87.9999 627.665 146.875 704 219.5 704C292.125 704 351 627.665 351 533.5C351 510.478 347.479 488.522 341.101 468.486C356.345 455.19 366 435.489 366 413.5Z",
    fill: "#0A150F",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4148_19449",
    x: -260.005,
    y: -884.005,
    width: 934.01,
    height: 2404.01,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.5024,
    result: "effect1_foregroundBlur_4148_19449"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4148_19449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 445,
    height: 960,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepth2);
export default __webpack_public_path__ + "static/media/depth2.04255f420a0e26374cd06c40a472d834.svg";
export { ForwardRef as ReactComponent };